import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { AccordionSection } from 'widgets/CallPopUp/ui/components/AccordionSection/AccordionSection'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { ContactsList } from 'widgets/CallPopUp/ui/components/ContactsList/ContactsList'
import {
  AcceptDeclineActions,
  IncomingBottomContent,
} from 'widgets/CallPopUp/ui/components/ContactsList/parts'

export const CallRingingContent = observer(() => {
  const { callPopUpRingingStore, innerRefTooltipCurrent, isCreatedConference } =
    useCallPopUpDefaultContext()
  const { items, count, handleAccept, handleDecline, handleDeclineAll } = callPopUpRingingStore

  return (
    <AccordionSection
      count={count}
      title={'Ringing'}
      show
      showIconButton
      renderButton={
        <Button
          text={'Decline all'}
          typeBtn={'contained'}
          contained={'secondary'}
          intent={'destructive'}
          size={'small'}
          disabled={!count}
          onClick={handleDeclineAll}
        />
      }
    >
      <ContactsList
        items={items}
        ariaLabel={'RingingContactsList'}
        autoHeightMax={280}
        alwaysShowActions
        renderBottom={(item) => <IncomingBottomContent item={item} />}
        renderActions={(item) => (
          <AcceptDeclineActions
            item={item}
            onAccept={(contact) => handleAccept(contact.sid)}
            onDecline={(contact) => handleDecline(contact.sid)}
            acceptDisabled={isCreatedConference}
            acceptDisabledTooltip={"You can't answer a new call during a conference call."}
            innerRefCurrent={innerRefTooltipCurrent || undefined}
          />
        )}
      />
    </AccordionSection>
  )
})
